// extracted by mini-css-extract-plugin
module.exports = {"loader":"Items_loader__1hI4Y","spin":"Items_spin__2P4Rr"};